'use strict';

import React, { Component } from 'react'

import getErrorsFromResponse from '@/Form/Functions/getErrorsFromResponse'
import getFormStatus         from '@/Form/Functions/getFormStatus'

import { handleChange } from '@/Form/Functions/eventsHandling'

import FormElement from '@/Form/toolkit/FormElement'

import Loader from '@Pure/Loader'
import Modal  from '@Modal/Modal'

let app = window.app;

export default class OrderCommentModal extends Component
{
	state =
	{
		open: false,
		form_data: { }
	};

	handleChange = handleChange.bind(this);

	componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.push(
		{
			event: 'open__OrderCommentModal',
			cb: component.open
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'open__OrderCommentModal',
			cb: component.open
		});
	}

	handleClose = (e, force) =>
	{
		const component = this, props = this.props, state = this.state;

		if (state.loading === true && !force)
		{
			return e.stopPropagation();
		}

		component.setState(
		{
			open: false,
			loading: false
		});
	}

	open = ({ order }) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			open : true,
			order: order,
			form_data: { comment: order.admin_comment }
		});
	}

	validate = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			loading: true
		});

		qwest.post('/order/update-admin-comment',
		{
			id: state.order.id,
			comment: state.form_data.comment
		})
		.then(function (xhr, response)
		{
			app.emit('changedOrderComment',
			{
				id: component.state.order.id,
				comment: state.form_data.comment
			});

			component.handleClose(e, true);
		})
		.catch(function (error, xhr, response)
		{
			console.error(response?.error || response?.raw || error);

			component.setState(
			{
				...getErrorsFromResponse(
				{
					response: response
				})
			});
		});
	}

	render ()
	{
		const props = this.props, component = this, state = this.state;

		const loader = state.loading === true ?
		(
			<Loader className="c-loader" bemit={ ['primary', 'bg-white'] } />
		)
		: undefined;

		let output =
		(
			<Modal open={ state.open } onClose={ component.handleClose }
				title="Note interne" hide_close={ true }>

				<FormElement className="u-margin-top-20"
					type="text" name="comment" data={ state.form_data }
					placeholder="Invisible pour le client"
					label="Note interne"
					onChange={ component.handleChange }
				/>

				{ getFormStatus(state) }

				<div className="c-dialog__buttons u-flex u-flex-wrap
					u-content-between">

					<div className="u-full-width">
						<button className="c-btn c-btn--green
							c-dialog__danger u-margin-right-15"
							onClick={ component.validate }>
							Valider
						</button>

						<button className="c-btn c-dialog__cancel"
							onClick={ component.handleClose }>
							Fermer
						</button>
					</div>

				</div>

				{ loader }

			</Modal>
		);

		return output;
	}
}
